import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { hideToast } from '../actions/toast';
import { InlineLoader } from '../../App/components/Loader';

import ExitIcon from '../../../images/exit.svg';

export default function Toast() {
  const { text, isVisible, isBusy } = useSelector((state) => state.toast);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  if (!isVisible) {
    return null;
  }
  return (
    <section className="toast" role="status" aria-live="polite">
      <p className="toast__message">
        {/* Operation in progress: the same two-ball spinner as the page Loader, inline. */}
        {isBusy && <InlineLoader />}
        <span>{t(text)}</span>
      </p>
      <button
        className="toast__close"
        onClick={() => dispatch(hideToast())}
        aria-label={t('Toast.CloseAlertARIA')}
      >
        <ExitIcon focusable="false" aria-hidden="true" />
      </button>
    </section>
  );
}
